// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wg1r","step":"styles_step__jfK9d","marker":"styles_marker__ueXll","highlight":"styles_highlight__3dmFF","label":"styles_label__3LMUb"};